import {
  IonIcon,
  IonItem,
  IonLabel,
  IonModal,
  IonButton,
  IonText,
} from "@ionic/react";
import { bulbOutline } from "ionicons/icons";
import React, { useState } from "react";
import "./IdeathonWebsite.css";

function IdeathonWebsite() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <IonItem className="ion-hide-sm-down">
        <IonIcon icon={bulbOutline} slot="start" className="ion-icon" />
        <IonLabel className="ion-text-wrap">
          TechTeam Ideathon 2021 Landing Page
        </IonLabel>

        <IonModal isOpen={showModal} className="ion-modal-popup">
          <IonText className="ion-justify-content-center ion-align-items-center ion-margin">
            <br />
            <b>TechTeam Ideathon Landing Page</b>
            <br />
            <p>
              In Spring 2021,{" "}
              <a
                href="https://www.uchicagotechteam.com/"
                target="_blank"
                rel="noreferrer"
              >
                TechTeam
              </a>{" "}
              launched its inaugural virtual Ideathon. As part of a
              collaborative effort, we designed and built this website using{" "}
              <code>HTML, CSS, Javascript, and Bootstrap</code>.
            </p>

            <a
              href="https://uctechteam.github.io/techteamideathon2021/about.html"
              target="_blank"
              rel="noreferrer"
            >
              Click here to see the website on a new page.
            </a>
            <br />
            <IonButton
              className="ion-button"
              onClick={() => setShowModal(false)}
            >
              Close
            </IonButton>

            <iframe
              src="https://uctechteam.github.io/techteamideathon2021/about.html"
              name="iframe_a"
              height="500px"
              width="100%"
              title="Iframe Example"
            ></iframe>

            <br />
          </IonText>
        </IonModal>

        <IonButton className="ion-button" onClick={() => setShowModal(true)}>
          Show
        </IonButton>
      </IonItem>

    </div>
  );
}

export default IdeathonWebsite;
